<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <large-base-card>
    <div class="d-flex align-center">
      <div class="text-h4">
        {{ $t('methodPayment') }}
      </div>
      <v-spacer/>
      <div
        class="d-flex align-center"
        style="height: 48px;"
      >
        <v-icon>mdi-cash-multiple</v-icon>
      </div>
    </div>
    <div
      class="mt-4"
      style="height: 400px;overflow-y: scroll"
    >
      <v-card
        v-for="p in filledPaidInfo"
        :key="p.id"
        class="mb-2 pa-0 text-body-2"
        elevation="0"
        style="position:relative;"
        tile
      >
        <div
          style="z-index: 1"
        >
          <div class="d-flex align-center">
            <div class="text-body-1">
              {{ p.paidName }}
            </div>
            <v-spacer/>
            <div class="d-flex align-center mt-2 text-body-2">
              {{ p.paidTotal | priceDisplay }}({{ p.paidCount }})
            </div>
          </div>

          <v-card
            :style="{width:p.paidPercentage+'%'}"
            class="mt-2"
            elevation="0"
            style="height: 16px;background:rgba(76,175,80,0.26);z-index: 0"
          />
        </div>
      </v-card>
    </div>
  </large-base-card>
</template>

<script>
  import { comparator, loadDashboardData } from '@/model/DashboardService'
  import Payment from '@/model/common/Payment'
  import LargeBaseCard from '@/composable/LargeBaseCard'

  export default {
    components: { LargeBaseCard },
    props: {
      date: {},
    },
    data: function () {
      return {
        paymentMethodList: [],
        paidInfo: [],
      }
    },
    computed: {
      filledPaidInfo () {
        const totalPayment = this.paidInfo.reduce((sum, i) => sum + parseFloat(i.paidTotal), 0.01)
        return this.paymentMethodList.filter(p => p.id > 0).map(p => {
          const r = this.paidInfo.find(t => parseInt(t.id) === parseInt(p.id))
          return {
            paidName: p._langsname,
            paidCount: r?.paidCount ?? 0,
            paidTotal: r?.paidTotal ?? 0,
            paidPercentage: (r?.paidTotal ?? 0) / totalPayment * 100,
            id: p.id,
          }
        }).filter(it => it.paidTotal > 0).sort((a, b) => comparator(b.paidCount, a.paidCount))
      },
    },
    async mounted () {
      this.paidInfo = (await loadDashboardData(this.date)).taxInfos.content.paidInfo
      this.paymentMethodList = await Payment.getList()
    },
    methods: {},
  }
</script>
